<div class="polizza-view-wrapper" *ngIf='polizza'>
    <mat-sidenav-container>
        <mat-sidenav #sidenav mode="side" opened>
            <button title="Chiudi barra di navigazione verticale" mat-icon-button (click)="sidenav.close()"
                class="sidenav-closer">
                <mat-icon>
                    close
                </mat-icon>
            </button>
            <h5 class="text-center mb-4 px-5">
                Polizza {{polizza.humanIdentifier}}
            </h5>
            <ul class="macro-links">
                <li routerLinkActive="active-macro">
                    <h6>
                        Generale
                    </h6>
                    <ul>
                        <li>
                            <div routerLink="./" routerLinkActive="active-link">Modifica</div>
                        </li>
                        <li>
                            <div routerLink="somme-assicurate" routerLinkActive="active-link">Somme Assicurate</div>
                        </li>
                    </ul>
                </li>
            </ul>

        </mat-sidenav>
        <mat-sidenav-content class="p-3">
            <router-outlet>
            </router-outlet>
        </mat-sidenav-content>
    </mat-sidenav-container>
    <button title="Apri barra di navigazione verticale" class="sidenav-opener" *ngIf="!sidenav.opened" mat-icon-button
        (click)="sidenav.open()">
        <mat-icon>
            keyboard_arrow_right
        </mat-icon>
    </button>

</div>